import { forwardRef } from 'react';
import {
  IconButton,
  Snackbar,
  Alert as MuiAlert,
  Slide,
  type SlideProps,
  type AlertProps
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SlideTransition = forwardRef((props: SlideProps, ref) => (
  <Slide {...props} ref={ref} direction="left" />
));

interface ToastProps {
  open: boolean;
  onClose: () => void;
  severity: 'info' | 'error' | 'success' | 'warning';
  message: string;
}

const Toast = (props: ToastProps) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={props.open}
      autoHideDuration={5000}
      onClose={props.onClose}
      TransitionComponent={SlideTransition}
    >
      <Alert
        sx={{ width: '100%' }}
        severity={props.severity}
        action={
          <IconButton color="inherit" size="small" onClick={props.onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {props.message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
